import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, FormGroup, Label, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import EmployeeSelect from "../../../../Components/Common/EmployeeSelect";
import TeamSelect from "../../../../Components/Common/TeamSelect";
import { DatePicker } from "../../../../Components/Common/Flatpicker";
import { CommonLabel } from "../../../../Components/Common/CommonLabel";
import { MultiSelect } from "react-multi-select-component";
import { LEAD_NOT_CONTACTED_REPORT } from "../../../../helpers/url_helper";
import { getPreviousCallAnalysisDate, getPreviousDate, setCurrentDate } from "../../../../Components/Common/DefaultDateSet";
import { formatFlatPickerDates, getBackgroundColor } from "../../../../Components/Common/ToCamelCase";
import { APIClient } from "../../../../helpers/api_helper";
import { useSelector } from "react-redux";
import { CommanDataTables } from "../../../../Components/Common/DashboardDataTbale";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useProfileData } from "../../../../Components/Hooks/UserHooks";
import CalculateRemainingDays from "../../../../Components/Common/CalculateRemainingDays";
import SubExpired from "../../../../Components/Common/subExpired";
import { addMonths } from "../../../../Components/Common/FlatePicker";

const api = new APIClient();

const NotContactedLead = () => {
    const { statusOptions } = useSelector((state) => state.leadStatusReducer);
    // default date
    const previewsDate = getPreviousDate();
    const currentDate = setCurrentDate();
    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);
    const [selectedNotContactedFromDate, setSelectedNotContactedFromDate] = useState(currentDate);

    // Memoized formatted dates
    const formattedDates = useMemo(
        () => formatFlatPickerDates(selectedFromDate, selectedToDate),
        [selectedFromDate, selectedToDate]
    );

    // Memoized date object using formattedDates
    const dateObj = useMemo(
        () => ({
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
        }),
        [formattedDates]
    );

    const [EmployeeData, setEmployeeData] = useState([]);
    const [teamIndu, setTeamIndu] = useState([]);
    const [getLeadStatus, setGetLeadStatus] = useState([]);

    // Modal Edit Delete
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // All edit lead function
    const notconnectedEditButton = useCallback((arg) => {
        setIsModalOpen(true);
    }, []);

    //

    // filter data
    const [filterData, setFilteredData] = useState([]);
    const [leadNotContactedReport, setLeadNotContactedReport] = useState([]);
    // employee wise state
    const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
    const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
    const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState([]);
    const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);
    const [prevstatus_Test, setPrevstatus_Test] = useState([]);
    const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // error message show in not a select empty
    const [error, setError] = useState("");
    const [statusError, setStatusError] = useState("");

    // all select row lead edit and remove
    const handlenotconnectedcall =
        () =>
            ({ selectedRows }) => {
                if (selectedRows && selectedRows.length > 0) {
                    setCheckOpen(true);
                    const lead_id = selectedRows.map((item) => item._id);
                    setAllLeadRemoveId(lead_id);
                } else {
                    setCheckOpen(false);
                    setAllLeadRemoveId([]);
                }
            };
    const [checkOpen, setCheckOpen] = useState(false);
    const [allLeadRemoveId, setAllLeadRemoveId] = useState([]);

    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    const navigate = useNavigate();
    const { profileData } = useProfileData();
    const remainingDays = CalculateRemainingDays();

    const columns = [
        {
            name: <span className="font-weight-bold fs-13">S No.</span>,
            selector: (row, index) => index + 1,
            sortable: false,
            width: "80px",
        },
        {
            name: <span className="font-weight-bold fs-13">Lead Name</span>,
            selector: (row) => row.firstName,
            cell: (row) => (
                <div className="d-flex align-items-center">
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row.firstName),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.firstName ? row.firstName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}
                    <span>
                        {row.firstName} {row.lastName}
                    </span>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Lead Added Date</span>,
            selector: (row) => row.createdAt || "-",
            cell: (row) => <span>{moment(row.createdAt).format("DD  MMM  YYYY") || "-"}</span>,
            sortable: true,
        },

        {
            name: <span className="font-weight-bold fs-13">Lead Number</span>,
            selector: (row) => row.phone || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Reminder Date</span>,
            selector: (row) => row.notContactNumberReminder || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Assign To</span>,
            selector: (row) => row.assignedTo[0]?.fullName || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Last Call Time</span>,
            selector: (row) => row.notcontactcalltime || "-",
            sortable: true,
        },
    ];


    const isWithinRange = (date) => {
        const today = new Date();
        return date >= selectedFromDate && date <= today;
    };

    // to From Date funcion
    const handleFromDateChange = (dates) => {
        const newFromDate = dates[0];
        setSelectedFromDate(newFromDate);
        const today = new Date();
        const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

        if (selectedToDate >= newFromDate && selectedToDate <= threeMonthsAfterFromDate) {
            return;
        }
        const newToDate = threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
        setSelectedToDate(newToDate);
    };


    // To Date function
    const handleToDateChange = (dates) => {
        const newToDate = dates[0];
        if (isWithinRange(newToDate)) {
            setSelectedToDate(newToDate);
        } else {
            console.warn("Selected date is out of range.");
        }
    };



    // Not Contacted Since FUNCTION
    const handleNotContactedFromDateChange = (dates) => {
        const newToDate = dates[0];
        setSelectedNotContactedFromDate(newToDate);
    };

    // filter status select function
    const handleStatusChange = (selectedOptions) => {
        if (selectedOptions) {
            setGetLeadStatus(selectedOptions);
            setStatusError("");
        }
    };
    const [isModalOpen, setIsModalOpen] = useState(false);

    // api credentials pass in function
    const getRequestData = useCallback(
        (updatedIds = [], leadsStatus = [], dateObj = {}, selectedNotContactedFromDate = {}) => {
            return {
                employeeIds: updatedIds || selectedEmployeeOptions2.map((userid) => userid?.id),
                startDate: dateObj.startDate,
                endDate: dateObj.endDate,
                contactedSince: selectedNotContactedFromDate,
                leadStatus: leadsStatus || getLeadStatus?.map((lead) => lead?.value),
            };
        },
        [formattedDates, selectedEmployeeOptions2, getLeadStatus]
    );

    // all api fetch data
    const fetchNotContactedReport = useCallback(
        async (updatedIds = [], leadsStatus = [], dateObj = {}, selectedNotContactedFromDate = {}) => {
            setIsLoading(true);
            try {
                // Get request payload
                const requestData = getRequestData(updatedIds, leadsStatus, dateObj, selectedNotContactedFromDate);
                const response = await api.create(`${LEAD_NOT_CONTACTED_REPORT}`, requestData);
                if (response?.success) {
                    setLeadNotContactedReport(response.data.leads);
                }
            } catch (error) {
                console.error("Error fetching report:", error);
            } finally {
                setIsLoading(false);
            }
        },
        [getRequestData]
    );

    // default data show in DataTable
    useEffect(() => {
        if (teamIndu) {
            if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
                let leadsStatus =
                    prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
                let updatedIds =
                    prevEmployeesIds_Test.length > 0
                        ? prevEmployeesIds_Test
                        : selectedEmployeeOptions2?.map((option) => option?.id) || [];
                if (updatedIds.length > 0) {
                    fetchNotContactedReport(updatedIds, leadsStatus, dateObj, selectedNotContactedFromDate);
                }
                setIsFirstEffectRun(true);
                setPrevEmployeesIds_Test(updatedIds);
                setPrevstatus_Test(leadsStatus);
            }
        } else {
            let leadsStatus =
                prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
            let updatedIds =
                prevEmployeesIds_Test.length > 0
                    ? prevEmployeesIds_Test
                    : EmployeeDefaultWithoutTeam?.map((option) => option?.id) || [];
            if (updatedIds.length > 0) {
                fetchNotContactedReport(updatedIds, leadsStatus, dateObj, selectedNotContactedFromDate);
            }
            setIsFirstEffectRun(true);
            setPrevEmployeesIds_Test(updatedIds);
            setPrevstatus_Test(leadsStatus);
        }
    }, [selectedEmployeeOptions, selectedNotContactedFromDate]);

    // Lead List Table data Submit data
    const handleApplySubmit = async () => {
        if (selectedEmployeeOptions.length === 0) {
            setError("You must select at least one");
        } else {
            let leadsStatus =
                prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
            let updatedIdss = selectedEmployeeOptions.map((userid) => userid?.id);
            fetchNotContactedReport(updatedIdss, leadsStatus, dateObj, selectedNotContactedFromDate);
            setError("");
        }
    };

    const toggle = () => {
        setIsModalOpen(!isModalOpen);
        resetForm();
    };
    const resetForm = () => {
        // Reset form logic here
    };
    const nocconnectedDeleteButton = () => {
        console.log("Delete button clicked");
    };

    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
    };


    return (
        <div>
            {remainingDays === 0 && isExpiredModalOpen && (
                <SubExpired
                    onClose={handleClose}
                    profileData={profileData?.selectedPlanDetails?.planName}
                    remainingDays={remainingDays}
                />
            )}
            <div className="page-content">
                <div className="container-fluid">
                    {/* title */}
                    <Row>
                        <BreadCrumb title="Not Contacted Leads" pageTitle="Not Contacted Leads" />
                    </Row>
                    {/*  */}
                    <Row>
                        <Card className="pt-4">
                            <Row>
                                <div className="sn-report-lead-tabs">
                                    <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
                                        <Col sm={2}>
                                            <DatePicker
                                                labelContent="Lead Created From Date"
                                                getDate={selectedFromDate}
                                                options={{
                                                    disable: [
                                                        {
                                                            from: new Date(),
                                                        },
                                                    ],
                                                    dateFormat: "d M, Y",
                                                    maxDate: new Date(new Date().setDate(new Date().getDate())),
                                                }}
                                                onChange={handleFromDateChange}
                                            />
                                        </Col>

                                        <Col sm={2}>
                                            <DatePicker
                                                labelContent="Lead Created To Date"
                                                getDate={selectedToDate}
                                                options={{
                                                    dateFormat: "d M, Y",
                                                    minDate: selectedFromDate,
                                                    // maxDate: 'today',
                                                    enable: [
                                                        {
                                                            from: selectedFromDate,
                                                            to: Math.min(
                                                                addMonths(selectedFromDate, 3),
                                                                new Date()
                                                            ),
                                                        },
                                                    ],
                                                    onOpen: () => {
                                                        const currentDate = new Date();
                                                        const threeMonthsFromStart = addMonths(
                                                            selectedFromDate,
                                                            3
                                                        );
                                                        if (threeMonthsFromStart > currentDate) {
                                                            return {
                                                                enable: [
                                                                    {
                                                                        from: selectedFromDate,
                                                                        to: currentDate,
                                                                    },
                                                                ],
                                                            };
                                                        }
                                                    },
                                                }}
                                                onChange={handleToDateChange}
                                            />

                                        </Col>

                                    
                                        <Col sm={3}>
                                            <div className="mb-3">
                                                <TeamSelect
                                                    setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                    teamIndu={teamIndu}
                                                    setTeamIndu={setTeamIndu}
                                                    labelContent="Select Team"
                                                />
                                            </div>
                                        </Col>

                                        <Col sm={3}>
                                            <div className="mb-3">
                                                <EmployeeSelect
                                                    setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                                                    EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                                                    error={error}
                                                    setError={setError}
                                                    EmployeeDefault={
                                                        teamIndu.length === 0
                                                            ? EmployeeDefaultWithoutTeam
                                                            : EmployeeData
                                                    }
                                                    setEmployeeDefault={setEmployeeData}
                                                    teamIndu={teamIndu}
                                                    selectedEmployeeOptions={selectedEmployeeOptions}
                                                    setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                    setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                                                    labelContent="Select Employee"
                                                />
                                            </div>
                                        </Col>

                                        <Col
                                            sm={2}
                                            className="sn-dasboard-datepicker-btn-main mt-0 sn-bulk-report-analysis-date"
                                        >
                                            <DatePicker
                                                labelContent="Not Contacted Since"
                                                getDate={selectedNotContactedFromDate}
                                                options={{
                                                    dateFormat: "d M, Y",
                                                    minDate: selectedFromDate,
                                                }}
                                                onChange={handleNotContactedFromDateChange}
                                                className="w-100  rounded dropdown-container h-40"
                                            />
                                        </Col>

                                        
                                        <Col sm={2} className="sn-header-select-employess-home">
                                            <CommonLabel htmlFor="leadstatus" isRequired>
                                                Select Lead Status
                                            </CommonLabel>

                                            <MultiSelect
                                                options={statusOptions}
                                                value={getLeadStatus}
                                                onChange={handleStatusChange}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                overrideStrings={{ selectSomeItems: "Select Leads" }}
                                                hasSelectAll={true}
                                                className="classgroup"
                                            />
                                            {statusError && (
                                                <small
                                                    className="sales-ninja-select-maltipale-lable"
                                                    style={{
                                                        color: "red",
                                                        position: "absolute",
                                                        bottom: "2px",
                                                        left: "22px",
                                                    }}
                                                >
                                                    <span></span>
                                                    {statusError}
                                                </small>
                                            )}
                                        </Col>

                                        <Col sm={2}>
                                            <FormGroup>
                                                <Label for="exampleSelect"></Label>
                                                <div id="exampleSelect" className="sn-call-apply-btn-reset mt-2">
                                                    <Button
                                                        id="exampleSelect"
                                                        type="submit"
                                                        color="danger"
                                                        className=""
                                                        onClick={handleApplySubmit}
                                                        disabled={isLoading}
                                                    >
                                                        Apply
                                                    </Button>
                                                    <Button
                                                        className=""
                                                        style={{ marginLeft: "10px" }}
                                                        id="exampleSelect"
                                                        outline
                                                        color="danger"
                                                        // onClick={resetInputHistory}
                                                        disabled={isLoading}
                                                    >
                                                        Reset
                                                    </Button>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>
                            <Row>
                                <div
                                    className="sn-add-import-lead-filter-button"
                                    style={{ position: "relative", display: "inline-flex" }}
                                >
                                    {/* <Button className="btn btn-danger" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                                <i className="ri-filter-line"></i>
                                            </Button>&nbsp; */}
                                    {checkOpen && (
                                        <>
                                            <Button
                                                className="btn btn-danger ml-1 sn-table-edit-button-main"
                                                onClick={() => notconnectedEditButton()}
                                            >
                                                Edit
                                            </Button>{" "}
                                            &nbsp;&nbsp;
                                            <Button
                                                className="btn btn-outline-danger text-danger bg-white"
                                                onClick={() => nocconnectedDeleteButton()}
                                            >
                                                Delete
                                            </Button>
                                        </>
                                    )}
                                </div>
                                <Col sm="12">
                                    <CommanDataTables
                                        onSelectedRowsChange={handlenotconnectedcall()}
                                        isLoading={isLoading}
                                        selectableRows
                                        column={columns}
                                        tableData={leadNotContactedReport}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default NotContactedLead;
